<template>
  <div
      :class="{
          'page-header d-flex flex-row justify-content-between align-items-center':true,
          'padleft': !leftDrawerOpen,
          'padright': !rightDrawerOpen ,
          'sticky':stickyHeader,
          'sticky-left': stickyHeader && screenSizeId >= 3 ? leftDrawerOpen: false,
          'sticky-right': stickyHeader &&  screenSizeId >= 3 ? rightDrawerOpen : false,
        }"
      style="height: 70px; min-height: 70px; max-height: 70px; z-index: 2;"
  >
    <div class="d-flex flex-row align-items-center flex-nowrap" style="flex-grow: 1">
      <h4 class="mb-0 mr-1" v-if="cPageTitle"> {{ cPageTitle }} </h4>
      <h5 class="mb-0 ml-1" v-if="cPageSubtitle">{{ cPageSubtitle }}</h5>
      <h5 class="mb-0 ml-1">
        <router-link :to="`/${cLinkPath}`" v-if="cLinkTitle || cLinkPath">
          {{ `${cLinkTitle ? cLinkTitle : cLinkPath}` }}
        </router-link>
      </h5>
      <ks-text v-if="qaAble" :text="pageRequiredPermissions"/>
      <ks-search
          v-if="showDefaultSearch && (hideOnScreenSizeChange ? screenSizeId >= 3 : true)"
          :preAndPostPend="preAndPostPend"
          :showSelectedInButton="showSelectedInButton"
          :modeOptions="modeOptions"
          :defaultModeInclude="defaultModeInclude"
          :defaultSearchWidth="defaultSearchWidth"
          :searchPlaceholder="searchPlaceholder"
          :dataProvider="dataProvider"
          :modeCodeId="modeCodeId"
      />
      <slot :record="data_provider_ref.record" :dataProvider="data_provider_ref"></slot>
      <ks-button
          style="margin-left: auto;"
          :style="'min-width: ' + minNewButtonWidth"
          v-if="showNewButton"
          :size="screenSizeId >= 3 ? 'md' : 'sm'"
          :color="screenSizeId >= 3 ? '' : 'link'"
          :label="NewButtonLabel"
          :showFloatingInMobile="true"
          :classIcon="newButtonIcon"
          @onClick="$emit('newButtonClicked')"
      />
    </div>
  </div>
</template>

<script>
import getStringTemplate from '../../../helpers/getStringTemplate';
import onMountedDataProvider from '../../../mixins/onMountedDataProvider';

export default {
  name: "ks-page-header",
  mixins: [onMountedDataProvider],
  props: {
     preAndPostPend:             {type: Boolean, default: false}
    ,showSelectedInButton:       {type: Boolean, default: true}
    ,modeOptions:                {type: Array,   default: () => []}
    ,defaultModeInclude:         {type: String,  default: null}
    ,newButtonIcon:              {type: String,  default: 'fas fa-plus'}
    ,linkTitle:                  {type: String,  default: null}
    ,linkPath:                   {type: String,  default: null}
    ,pageSubTitle:               {type: String,  default: null}
    ,showNewButton:              {type: Boolean, default: true}
    ,NewButtonLabel:             {type: String,  default: null}
    ,pageTitle:                  {type: String,  default: null}
    ,dataProvider:               {type: String,  default: null}
    ,modeCodeId:                 {type: String,  default: null}
    ,buttonTitle:                {type: String,  default: 'Add'}
    ,activeViewType:             {type: String,  default: null}
    ,searchPlaceholder:          {type: String,  default: 'Search...'}
    ,showDefaultSearch:          {type: Boolean, default: false}
    ,preventDefaultClearSearch:  {type: Boolean, default: false}
    ,defaultSearchWidth:         {type: String,  default: '400px'}
    ,hideOnScreenSizeChange:     {type: Boolean, default: true},
    minNewButtonWidth: {type: String, default: '150px'},
  },
  methods: {},
  computed: {
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    },
    pageRequiredPermissions(){
      return this.$route.meta.middlewares && this.$route.meta.middlewares.length >0?this.$route.meta.middlewares[0]["rms_ui/validatePermissionsMiddleware"][0]:null;
    },
    stickyHeader() {
      return this.$parent.stickyHeader;
    },
    leftDrawerOpen() {
      return this.$parent.leftDrawerOpen
    },
    rightDrawerOpen() {
      return this.$parent.rightDrawerOpen
    },
    cDataProvider() {
      return this.dataProvider ? this.dataProvider : (this.$parent.dataProvider ? this.$parent.dataProvider : null);
    },
    screenSizeId() {
      return app.layout.screenSizeId;
    }
  },
  async mounted() {
    if (this.cDataProvider) {
      await this.onMountedDataProvider();
      if (this.linkPath) this.cLinkPath = getStringTemplate(this.linkPath, {...this.data_provider_ref.getFilters(), ...this.data_provider_ref.getLocalRecord()});
      if (this.linkTitle) {this.cLinkTitle = getStringTemplate(this.linkTitle, {...this.data_provider_ref.getFilters(), ...this.data_provider_ref.getLocalRecord()});}
      if (this.pageTitle) this.cPageTitle = getStringTemplate(this.pageTitle, {...this.data_provider_ref.getFilters(), ...this.data_provider_ref.getLocalRecord()});
      if (this.pageSubTitle) this.cPageSubtitle = getStringTemplate(this.pageSubTitle, {...this.data_provider_ref.getFilters(), ...this.data_provider_ref.getLocalRecord()});
    } else {
      this.cLinkPath = this.linkPath;
      this.cLinkTitle = this.linkTitle;
      this.cPageTitle = this.pageTitle;
      this.cPageSubtitle = this.pageSubTitle;
    }
  },
  data() {
    return {
      timer: null
      ,cPageSubtitle: null
      ,cPageTitle: null
      ,cLinkTitle: null
      ,cLinkPath: null
      ,l_search_string: ''
    }
  }
}
</script>
